<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Solicitações de Alteração de Parceiro</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
                }}</span>
            </button>
            <button v-if="countFilter > 0" type="button" class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom title="Limpar filtros" @click="ResetFilter()">
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Solicitações</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0">
                    <button class="btn btn-outline-secondary dropdown-toggle-ellipsis" type="button"
                      v-b-tooltip.hover.right title="Mais opções" id="dropdownMenuButton" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#" :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)">
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelNameMerchant }}
                    </th>
                    <th scope="col" class="border-0">Parceiro</th>
                    <th scope="col" class="border-0">SDR</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0">Solicitante</th>
                    <th scope="col" class="border-0">Motivo</th>
                    <th scope="col" class="border-0">Data da solicitação</th>
                    <th scope="col" class="border-0">Nº de solicitações</th>
                    <th scope="col" class="border-0" v-if="$isAuthorize('MerchantSolicitation', 'Update')"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(
                      merchantSolicitation, index
                    ) in merchantSolicitations" :key="index">
                    <td></td>
                    <td class="text-left">
                      <div>
                        {{ merchantSolicitation.Merchant.Name | substring(50) }}
                      </div>
                      <span class="td-span-style" v-if="
                          merchantSolicitation.Merchant.SourceDescription !=
                            null &&
                          merchantSolicitation.Merchant.SourceDescription !=
                            undefined &&
                          merchantSolicitation.Merchant.SourceDescription != ''
                        ">
                        ORIGEM
                        {{
                        merchantSolicitation.Merchant.SourceDescription
                        }}</span>
                    </td>
                    <td>
                      <div v-if="
                          merchantSolicitation.Partner.Name != null &&
                          merchantSolicitation.Partner.Name != undefined &&
                          merchantSolicitation.Partner.Name != ''
                        ">
                        {{ merchantSolicitation.Partner.Name }}
                      </div>
                      <div v-else>SEM PARCEIRO</div>
                      <span class="td-span-style" v-if="
                          merchantSolicitation.PartnerPrevious.Name != null &&
                          merchantSolicitation.PartnerPrevious.Name !=
                            undefined &&
                          merchantSolicitation.PartnerPrevious.Name != '' &&
                          merchantSolicitation.MerchantSolicitationStatus
                            .Code != '2'
                        ">
                        PARCEIRO ATUAL:
                        {{
                        merchantSolicitation.PartnerPrevious.Name | split(" ")
                        }}</span>
                      <span class="td-span-style" v-else>
                        {{
                        merchantSolicitation.MerchantSolicitationStatus
                        .Code != 2
                        ? "PARCEIRO ATUAL: SEM PARCEIRO"
                        : ""
                        }}
                      </span>
                    </td>
                    <td>
                      <div v-if="
                          merchantSolicitation.PartnerSDR.Name != null &&
                          merchantSolicitation.PartnerSDR.Name != undefined &&
                          merchantSolicitation.PartnerSDR.Name != ''
                        ">
                        {{ merchantSolicitation.PartnerSDR.Name }}
                      </div>
                      <div v-else>SEM PARCEIRO SDR</div>
                      <span class="td-span-style" v-if="
                          merchantSolicitation.PartnerSDRPrevious.Name != null &&
                          merchantSolicitation.PartnerSDRPrevious.Name !=
                            undefined &&
                          merchantSolicitation.PartnerSDRPrevious.Name != '' &&
                          merchantSolicitation.MerchantSolicitationStatus
                            .Code != '2'
                        ">
                        PARCEIRO SDR ATUAL:
                        {{
                        merchantSolicitation.PartnerSDRPrevious.Name | split(" ")
                        }}</span>
                      <span class="td-span-style" v-else>
                        {{
                        merchantSolicitation.MerchantSolicitationStatus
                        .Code != 2
                        ? "PARCEIRO SDR ATUAL: SEM PARCEIRO SDR"
                        : ""
                        }}
                      </span>
                    </td>
                    <td>
                      <div>
                        {{
                        merchantSolicitation.MerchantSolicitationStatus.Name
                        }}
                      </div>
                      <span class="td-span-style" v-if="
                          merchantSolicitation.UserInternal.Name != null &&
                          merchantSolicitation.UserInternal.Name != undefined &&
                          merchantSolicitation.UserInternal.Name != ''
                        ">
                        POR
                        {{
                        merchantSolicitation.UserInternal.Name | split(" ")
                        }}</span>
                    </td>
                    <td>
                      {{
                      merchantSolicitation.UserInternalSolicitation.Name
                      | split(" ")
                      }}
                    </td>
                    <td class="td-font-small">
                      {{ merchantSolicitation.Reason }}
                    </td>
                    <td>{{ merchantSolicitation.CreatedDate | date }}</td>
                    <td>{{ merchantSolicitation.RequestNumber }}</td>
                    <td v-if="$isAuthorize('MerchantSolicitation', 'Update')">
                      <div class="dropdown">
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item" href="#" :class="
                              loadingApprove ||
                              merchantSolicitation.MerchantSolicitationStatus
                                .Code != '1'
                                ? 'disabled'
                                : ''
                            " v-on:click.stop="
                              ConfirmUpdateMerchantSolicitation(
                                $event,
                                index,
                                true
                              )
                            ">
                            <template v-if="loadingApprove">
                              <loader :small="true" :isLoading="loadingApprove"></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-check mr-2"></i>
                              Aprovar
                            </template>
                          </a>
                          <a class="dropdown-item" href="#" :class="
                              loadingDisapprove ||
                              merchantSolicitation.MerchantSolicitationStatus
                                .Code != '1'
                                ? 'disabled'
                                : ''
                            " v-on:click.stop="
                              ConfirmUpdateMerchantSolicitation(
                                $event,
                                index,
                                false
                              )
                            ">
                            <template v-if="loadingDisapprove">
                              <loader :small="true" :isLoading="loadingDisapprove"></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-times mr-2"></i>
                              Reprovar
                            </template>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="
                      merchantSolicitations == null ||
                      merchantSolicitations == undefined ||
                      merchantSolicitations.length == 0
                    ">
                    <td colspan="9">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination class="float-right" v-model="pagination.PageNumber" :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage" aria-controls="my-table"></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeMerchantSolicitationStatus" :value="null">
            <option :value="null" selected>Status</option>
            <option v-for="status in merchantSolicitationStatus" v-bind:key="status.Code" v-bind:value="status.Code">
              {{ status.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdUserInternalSolicitation" :value="null">
            <option :value="null" selected>Solicitante</option>
            <option v-for="userInternal in userInternals" v-bind:key="userInternal.Id" v-bind:value="userInternal.Id">
              {{ userInternal.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask class="form-control" type="tel" :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.IdentityMerchant" placeholder="CPF/CNPJ" v-on:keyup.enter.native="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <input :placeholder="labelNameMerchant" type="text" class="form-control" v-model="filter.NameMerchant"
            v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.InitialDate" placeholder="Data de solicitação Inicial"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.EndDate" placeholder="Data de solicitação Final"></date-field>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar"
          @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button variant="primary" class="input-group-text" v-b-tooltip.hover.bottom title="Limpar filtros"
          @click="ResetFilter()">
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { hasValue } from "../../utils/functions.js";
  import dateField from "../common/date-field";
  export default {
    name: "merchant-solicitations",
    components: {
    dateField,
  },
    data: function () {
      return {
        countFilter: 0,
        filter: {
          InitialDate: null,
          EndDate: null,
          CodeMerchantSolicitationStatus: this.listPending ? "1" : null,
          IdUserInternalSolicitation: null,
          IdentityMerchant: null,
          NameMerchant: null,
        },
        listPending: false,
        loadingList: false,
        loadingApprove: false,
        loadingDisapprove: false,
        loadingReport: false,
        pagination: {
          RowsPerPage: 10,
          PageNumber: 1,
          TotalItems: 0,
        },
        merchantSolicitationStatus: [],
        merchantSolicitations: [],
        partners: [],
        userInternals: [],
        labelNameMerchant: "Cliente",
      };
    },
    computed: {},
    watch: {
      "pagination.PageNumber": function () {
        this.ListMerchantSolicitation();
      },
      "pagination.RowsPerPage": function () {
        this.ListMerchantSolicitation();
      },
    },
    mounted() {
      if (this.$route.query.listPending == "true") {
        this.listPending = true;
        this.filter.CodeMerchantSolicitationStatus = "1";
      }
      this.ListMerchantSolicitation();
      this.ListMerchantSolicitationStatus();
      this.ListPartner();
      this.ListUserInternal();
    },
    methods: {
      OpenModalFilter: function () {
        this.$bvModal.show("mFilter");
      },
      Filter: function () {
        this.$bvModal.hide("mFilter");
        this.ListMerchantSolicitation();
      },
      ResetFilter: function () {
        this.filter = {
          InitialDate: null,
          EndDate: null,
          CodeMerchantSolicitationStatus: this.listPending ? "1" : null,
          IdUserInternalSolicitation: null,
          IdentityMerchant: null,
          NameMerchant: null,
        };
        this.ListMerchantSolicitation();
      },
      ListMerchantSolicitationStatus: function () {
        this.$store
          .dispatch("ListMerchantSolicitationStatus")
          .then((response) => {
            this.merchantSolicitationStatus = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao obter lista de status",
              error
            );
          });
      },
      ListPartner: function () {
        let data = { OrderByColumn: "Name" };
        this.$store
          .dispatch("ListPartner", { params: data })
          .then((response) => {
            this.partners = response.Objects;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao obter lista de parceiros",
              error
            );
          });
      },
      ListUserInternal: function () {
        this.$store
          .dispatch("ListUserInternal", { params: {} })
          .then((response) => {
            this.userInternals = response.Objects;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao obter lista de usuários internos",
              error
            );
          });
      },
      GetReport: function (ev) {
        ev.preventDefault();
        this.loadingReport = true;
        let data = this.GetParamsData(false);
        this.$store
          .dispatch("ReportMerchantSolicitation", { params: data })
          .then((response) => {
            if (
              response.UrlReport != null &&
              response.UrlReport != undefined &&
              response.UrlReport != ""
            ) {
              this.$makeToast(
                "Aguarde a conclusão do download",
                "info",
                "Relatório gerado com sucesso"
              );
              window.open(response.UrlReport, "_self");
            }
          })
          .catch((error) => {
            this.$makeToast(
              "Tente novamente mais tarde.",
              "danger",
              "Erro ao gerar o relatório",
              error
            );
          })
          .finally(() => {
            $("#dropTableOptions").dropdown("hide");
            setTimeout(() => {
              this.loadingReport = false;
            }, 1200);
          });
      },
      GetParamsData: function (deletePagination = false) {  
        let data = {
          ...this.pagination,
          ...{
            "InitialDate": this.filter.InitialDate,
            "EndDate": this.filter.EndDate,
            "Object.MerchantSolicitationStatus.Code": this.filter.CodeMerchantSolicitationStatus,
            "Object.UserInternalSolicitation.Id": this.filter.IdUserInternalSolicitation,
            "Object.Merchant.Identity": this.filter.IdentityMerchant,
            "Object.Merchant.Name": this.filter.NameMerchant,
          },
        };
        delete data.TotalItems;
        if (deletePagination) {
          delete data.RowsPerPage;
          delete data.PageNumber;
        }
        return data;
      },
      ListMerchantSolicitation: function () {
        this.countFilter = 0;
        if (hasValue(this.filter.CodeMerchantSolicitationStatus))
          this.countFilter++;
        if (hasValue(this.filter.IdUserInternalSolicitation)) this.countFilter++;
        if (hasValue(this.filter.IdentityMerchant)) this.countFilter++;
        if (hasValue(this.filter.NameMerchant)) this.countFilter++;
        if (hasValue(this.filter.InitialDate)) this.countFilter++;
        if (hasValue(this.filter.EndDate)) this.countFilter++;

        if(hasValue(this.filter.InitialDate) && hasValue(this.filter.EndDate)){
          if (this.filter.InitialDate > this.filter.EndDate) {
          this.$makeToast("A data Final deve ser maior que a data Inicial.",
          "danger",
          "Data incorreta.",);
          this.loadingList = false;
          return;
        }
        }
        
        this.loadingList = true;
        let data = this.GetParamsData();
        delete data.TotalItems;
        this.$store
          .dispatch("ListMerchantSolicitation", { params: data })
          .then(
            (response) => {
              this.merchantSolicitations = response.Objects;
              this.pagination.TotalItems = response.TotalItems;
            },
            (error) => {
              this.$makeToast(
                "Não foi possível listar as solicitações",
                "danger",
                "Solicitações",
                error
              );
            }
          )
          .finally(() => {
            this.loadingList = false;
          });
      },
      ConfirmUpdateMerchantSolicitation: function (e, i, approve) {
        e.preventDefault();
        this.$makeMsgBox(
          `Você tem certeza que deseja ${approve ? "aprovar" : "reprovar"
          } esta solicitação?`,
          "Confirmar",
          this.UpdateMerchantSolicitation,
          i,
          approve
        );
      },
      UpdateMerchantSolicitation: function (i, approve) {
        let codeMerchantSolicitationStatus = "";
        let merchantSolicitation = this.merchantSolicitations[i];

        if (approve) {
          this.loadingApprove = true;
          codeMerchantSolicitationStatus = "2";
        } else {
          this.loadingDisapprove = true;
          codeMerchantSolicitationStatus = "3";
        }

        let infoMerchantSolicitation = {
          Id: merchantSolicitation.Id,
          MerchantSolicitationStatus: {
            Code: codeMerchantSolicitationStatus,
          },
          Merchant: {
            Name: merchantSolicitation.Merchant.Name,
          },
          UserInternalSolicitation: {
            Name: merchantSolicitation.UserInternalSolicitation.Name,
            Email: merchantSolicitation.UserInternalSolicitation.Email,
          },
        };

        this.$store
          .dispatch("UpdateMerchantSolicitation", infoMerchantSolicitation)
          .then(() => {
            this.$makeToast(
              "Sua resposta foi processada com sucesso",
              "success",
              "Solicitações"
            );
            this.ListMerchantSolicitation();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao processar sua resposta",
              error
            );
          })
          .finally(() => {
            if (approve) this.loadingApprove = false;
            else this.loadingDisapprove = false;
          });
      },
    },
  };
</script>

<style scoped>
  .td-span-style {
    font-size: 8pt;
    opacity: 0.75;
  }

  .td-font-small {
    font-size: 10pt;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/merchantSolicitations.vue